// extracted by mini-css-extract-plugin
module.exports = {"outer":"_1ChWS","heading":"_1Q8kG","stepsWrapper":"_2UFDO","steps":"D7-pi"};